import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchCompanySettings } from '../../actions/companyActions'

const useFetchingSettings = (id, isAdmin) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchCompanySettings(id, true, isAdmin))
  }, [dispatch, id])
}

export default useFetchingSettings
